import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import ModalBox from '../../../shared/modal';

import classname from 'classname';

lessRequire('modules/offers/components/popups/rules.less');

const DownloadPopup = props => {
	const className = classname({
		'ReactModal__Content': true,
		'ReactModal__Content--after-open': true,
		'modal-overlay__content': true,
		'rules-modal': true
	});

	return (
		<ModalBox
			body={ModalBody(props)}
			isOpen={props.isOpen}
			isFixedBody={!!props.isOpen}
			onClose={props.closeHtmlPopup}
			title={`${props.intl('Для работы потока по API необходимо качать архив в php')}`}
			className={className}
		/>
	);
};

const ModalBody = (props) => {

	function openHref(isPhp = false) {
		window.open(isPhp ? props.phpHref : props.htmlHref, '_blank');
		props.closeHtmlPopup();
	}

	return (
		<div className="html-warning-popup">
			<div className="warning-container">
				<button
					className="button yellow-btn font-proxima-nova-semibold"
					onClick={openHref.bind(null, true)}
				>
					{props.intl('Сохранить в php')}
				</button>
			</div>
			<div className="rule-wrap">
				<button className="button font-proxima-nova-semibold" onClick={openHref.bind(null, false)}>
					{props.intl('Сохранить в html')}
				</button>
			</div>
		</div>
	);
};

ModalBody.propTypes = {
	intl: PropTypes.func,
	selectedOffer: PropTypes.object
};

export default DownloadPopup;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/popups/html-warning.js